import React, { useState } from "react";
import { Text, View, Image } from "react-native";
import { AppImages } from "../../utility/AppImages";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { CommonButton } from "../../common/CommonButton";
import { SwitchCommon } from "../../common/SwitchCommon";
import { GameShow } from "../../utility/types/gameShowTypes";

type CallOutModalComponentProps = { styles?: any  , details : GameShow};

const CallOutModalComponent: React.FC<CallOutModalComponentProps> = ({
  styles,
}) => {
  const deviceSize = useDeviceSize();
  const [liveStream, setLiveStream] = useState(true);

  return (
    <>
      <View
        style={{
          flexDirection: "row",
          gap: 20,
          paddingHorizontal: 10,
        }}
      >
        <Image
          source={AppImages.whiteCircle}
          style={{
            height: 25,
            width: 23,
            resizeMode: "contain",
          }}
        />
        <View>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_15,
              {
                color: AppColors.white,
              },
            ]}
          >
            Switch to Kall-Out Event:
          </Text>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_10,
              {
                color: AppColors.gray_6E90B4,
                paddingTop: 10,
                width: deviceSize === DEVICE_SIZES.XS ? "20%" : "55%",
              },
            ]}
          >
            Switch to a Kall-out format using free streaming platforms like
            YouTube or Twitch. This option opens your event to all users and is
            no longer exclusive. Please select your preferred option to continue
            with your event.
          </Text>
        </View>
      </View>
      <View style={styles.benefitsData}>
        <View
          style={{
            flexDirection: "row",
            paddingHorizontal: 10,
            justifyContent: "space-between",
            width:
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? "100%"
                : "70%",
          }}
        >
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              {
                color: AppColors.white,
              },
            ]}
          >
            Live Streaming Setup
          </Text>

          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_12,
              {
                color: AppColors.white,
              },
            ]}
          >
            Enable/disable
          </Text>
        </View>
      </View>
      <View style={{ paddingHorizontal: 10 }}>
        <View
          style={{
            flexDirection: "row",
            paddingHorizontal: 10,
            justifyContent: "space-between",
            width:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "100%"
                : "70%",
          }}
        >
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_12,
              {
                color: AppColors.gray_C3C3C3,
              },
            ]}
          >
            Esquadifi
          </Text>

          <SwitchCommon
            switchState={liveStream}
            setSwitchState={setLiveStream}
          />
        </View>
      </View>
    </>
  );
};

export default CallOutModalComponent;
